import { axiosInstance } from "@/lib/axios"
import type { ArtistsQueryParams, ArtistsResponse } from "./types"
import { CollectionsResponse } from "../collections/types"

export type FollowStatusResponse = {
  data: {
    state: "FOLLOWED" | "NOT_FOLLOWED"
  }
  message: string
  next: null
  errors: null
  meta: any[]
}

/** No `watchlist` variant: artists support follow only, and `/artists/watchlist`
 *  is not a route (it 404s — it resolves as `/artists/{username}`). */
export async function getArtists(params: ArtistsQueryParams = {}, options?: { suppressToast?: boolean }): Promise<ArtistsResponse> {
  const p = new URLSearchParams()
  if (params.page) p.set("page", String(params.page))
  if (params.perPage) p.set("per_page", String(params.perPage))
  if (params.name) p.set("name", params.name)
  if (params.username) p.set("username", params.username)
  if (params.order) p.set("order", params.order)
  if (params.order_by) p.set("order_by", params.order_by)

  const { data } = await axiosInstance.get<ArtistsResponse>(`/artists?${p.toString()}`, options)
  return data
}

export async function getMyCollections(username: string, perPage = 100): Promise<CollectionsResponse> {
  const { data } = await axiosInstance.get<CollectionsResponse>(
    `/artists/my-collections/${username}?page=1&per_page=${perPage}`
  )
  return data
}

export async function getMyNfts(username: string, perPage = 100): Promise<any> {
  const { data } = await axiosInstance.get(`/artists/my-nfts/${username}?page=1&per_page=${perPage}`)
  return data
}

export async function getFollowStatus(username: string): Promise<FollowStatusResponse> {
  const { data } = await axiosInstance.get<FollowStatusResponse>(`/artists/${username}/follow`)
  return data
}

export async function followArtist(username: string): Promise<any> {
  const { data } = await axiosInstance.post(`/artists/${username}/follow`)
  return data
}

export async function unfollowArtist(username: string): Promise<any> {
  const { data } = await axiosInstance.delete(`/artists/${username}/follow`)
  return data
}
